import React, { useMemo } from "react";
import { AlertComparizonType, AlertNotification, AlertValueType } from "@shared/models";
import { getFormattedDateTime } from "@shared/utils";
import { Icon } from "@shared/components";
import { useGetDifferenceAlertTextShort } from "@containers/Alert/hooks";
import { IconType } from "@shared/components/Icon/Icon";

import "./index.scss";

interface AlertNotificationsRowComponentProps {
  item: AlertNotification;
}

const AlertNotificationsRowComponent = (props: AlertNotificationsRowComponentProps) => {
  const { item } = props;

  const differenceText = useGetDifferenceAlertTextShort(item, false);

  const notificationValue = useMemo(() => {
    return Number(item.value).toFixed(0);
  }, [item.value]);

  const notificationSignalType = useMemo(() => {
    return String(item.signal_type).toUpperCase();
  }, [item.signal_type]);

  const percentageColor = useMemo(() => {
    return item.comparison_type === AlertComparizonType.ABOVE ? "green" : "red";
  }, [item.comparison_type]);

  const percentageIcon = useMemo(() => {
    return item.comparison_type === AlertComparizonType.ABOVE ? "percentage-up" : "percentage-down";
  }, [item.comparison_type]);

  const isAbsolute = useMemo(() => {
    return item.value_type === AlertValueType.ABSOLUTE;
  }, [item.value_type]);

  const iconName = useMemo((): IconType => {
    if (item.alert_type) return `alert-${item.alert_type}-${item.comparison_type}`;

    return "alert-stable-parameter";
  }, [item]);

  return (
    <div className="alert-notification-row">
      <div className="alert-notification-row-name">
        {item.patient.last_name} {item.patient.first_name}
      </div>
      <div className="alert-notification-row-date">{getFormattedDateTime(item.created_at)}</div>
      <div className="alert-notification-row-value-wrapper">
        <div className="alert-notification-row-value-icon">
          <Icon type={iconName} />
        </div>
        <div className="alert-notification-row-value">
          <div className="alert-notification-row-value-top">
            {item.value_type !== AlertValueType.INSUFFICIENT_DATA ? (
              <span className="alert-notification-value">{notificationValue}</span>
            ) : null}
            <span className="alert-notification-signal-type">{notificationSignalType}</span>
            {differenceText ? <Icon className="alert-notification-percentage-icon" type={percentageIcon} /> : null}
            {differenceText ? (
              <span className={`alert-notification-percentage-value ${percentageColor}`}>
                {Number(differenceText).toFixed(0)}
                {isAbsolute ? "" : "%"}
              </span>
            ) : null}
          </div>
          <div className="alert-notification-row-value-bottom">{item.value_type}</div>
        </div>
      </div>
    </div>
  );
};

export default AlertNotificationsRowComponent;
